import { z } from 'zod';

import { TestSetStatusFilterSchema } from '@/features/stacktrace/test-sets/-constants';

import { TestSetTableColumns } from './-table/type';

/**
 * テストセット 一覧画面の URL search スキーマ。
 *
 * - status:        ステータスタブ用フィルタ（"ALL" + 6 ドメイン値）
 * - freeText:      検索バー（name 部分一致）
 * - pageIndex:     0-origin ページ番号
 * - pageSize:      1 ページあたりの件数
 * - sortColumn:    ソート対象カラム
 * - orderDirection ソート方向
 */
export const TestSetListPageFilterSchema = z.object({
  status: TestSetStatusFilterSchema.default('ALL'),
  productId: z.string().optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(TestSetTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
});
